;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('VulnerabilityTrendReportFilterManageCtrl', [
      '$scope',
      '$uibModalInstance',
      'VulnerabilityTrendReportFactory',
      'data',
      VulnerabilityTrendReportFilterManageCtrl
    ])

  function VulnerabilityTrendReportFilterManageCtrl(
    $scope,
    $uibModalInstance,
    VulnerabilityTrendReportFactory,
    data
  ) {
    angular.extend($scope, {
      model: {
        filter_search: '',
        is_select_all: false,
        to_update: [],
        to_delete: [],
        views: []
      }
    })

    angular.extend($scope, {
      cancel: cancel,
      done: done,
      onNameChange: onNameChange,
      toggleDelete: toggleDelete,
      toggleSelectAll: toggleSelectAll
    })

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function done() {
      var promises = []

      if ($scope.model.to_delete.length > 0) {
        promises.push(
          VulnerabilityTrendReportFactory.bulkDelete($scope.model.to_delete)
        )
      }

      if ($scope.model.to_update.length > 0) {
        promises.push(
          VulnerabilityTrendReportFactory.bulkEdit($scope.model.to_update)
        )
      }

      $uibModalInstance.close(promises)
    }

    function init() {
      var i = 0

      $scope.model.views = data.saved_views

      for (; i < data.saved_views.length; i++) {
        data.saved_views[i].deleted = false
        data.saved_views[i].edited = false
        data.saved_views[i].initial_name = data.saved_views[i].name
      }
    }

    function onNameChange(data, view) {
      if (data.length > 0) {
        if (data == view.initial_name) {
          $scope.model.to_update = _.reject(
            $scope.model.to_update,
            function (update) {
              return update.value == data.value
            }
          )

          view.name = view.initial_name

          view.edited = false
        } else {
          var prevView = _.find($scope.model.to_update, { id: view.value })

          if (prevView) {
            prevView.view_name = data
            view.name = data
          } else {
            $scope.model.to_update.push({ id: view.value, view_name: data })
            view.name = data
          }

          view.edited = true
        }
      }
    }

    function toggleDelete(view) {
      $scope.model.is_select_all = false

      var index = $scope.model.to_delete.indexOf(view.value)

      if (index > -1) {
        $scope.model.to_delete.splice(index, 1)

        view.deleted = false
      } else {
        $scope.model.to_delete.push(view.value)

        view.deleted = true
      }
    }

    function toggleSelectAll() {
      var i = 0

      if ($scope.model.is_select_all) {
        $scope.model.to_delete = []
        $scope.model.to_update = []

        for (; i < $scope.model.views.length; i++) {
          $scope.model.to_delete.push($scope.model.views[i].value)

          $scope.model.views[i].edited = false
          $scope.model.views[i].deleted = true
        }
      } else {
        $scope.model.to_delete = []

        for (; i < $scope.model.views.length; i++) {
          $scope.model.views[i].edited = false
          $scope.model.views[i].deleted = false
        }
      }
    }

    init()
  }
})()
